module.exports = __webpack_public_path__ + "static/media/logoc.dc8e9811.png";